import { useQuery } from '@tanstack/react-query';
import { useAPI } from '@pella/cosmos-react';
import { QUERY_KEYS } from '../../utils/enums';

/**
 * Hook to fetch all available inventory organization locations.
 * @returns {object} Inventory locations query result with data, loading, success, and error states.
 */
export const useInvLocations = () => {
  const { api, apiReady } = useAPI();
  const { data, isLoading, isSuccess, isError, error } = useQuery({
    queryKey: [QUERY_KEYS.INV_MGMT_INV_LOCATIONS],
    queryFn: () => api.invMgmt.getOrgInvLocations(),
    enabled: apiReady,
    staleTime: Number.POSITIVE_INFINITY,
  });
  return {
    invLocations: data,
    invLocationsIsLoading: isLoading,
    invLocationsIsSuccess: isSuccess,
    invLocationsIsError: isError,
    invLocationsError: error,
  };
};
